import { defineMessages } from 'react-intl';

export default defineMessages({
  SuccessCardBackToSignIn: {
    id: 'SuccessCardBackToSignIn',
    defaultMessage: 'Back to sign in',
  },
});
